import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

export const items = css`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  user-select: none;
`;
export const itemClickable = (theme: Theme) => css`
  border-radius: ${theme.borderRadius.circle};
  background: none;
  border: none;
  cursor: pointer;

  &:hover,
  &:focus {
    color: ${theme.palette.tertiary.upperMediumContrast};
    background: ${theme.palette.tertiary.lowContrast};
    font-weight: 500;
  }
`;

export const item = (theme: Theme) => css`
  height: 32px;
  width: 32px;
  text-align: center;
  font-size: 14px;
  color: ${theme.palette.tertiary.mediumContrastAlternative};
`;

export const dotSpaces = css`
  line-height: 32px;
`;

export const active = (theme: Theme) => css`
  background: ${theme.palette.secondary.lowContrast};
  color: ${theme.palette.primary.mainContrast};
  font-weight: 500;

  &:hover,
  &:focus {
    color: ${theme.palette.tertiary.upperMediumContrast};
    background: ${theme.palette.secondary.lowContrast};
    font-weight: 500;
  }
`;

export const arrowButton = (theme: Theme) => css`
  background: none;
  color: ${theme.palette.tertiary.mediumContrastAlternative};
  border: none;
  font-size: ${theme.spacing[20]};
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 32px;
  height: 32px;

  &:hover,
  &:focus,
  &:active {
    color: ${theme.palette.tertiary.upperMediumContrast};
  }

  &:disabled {
    color: ${theme.palette.tertiary.mediumContrast};
    cursor: default;
  }
`;
